/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Embed_Captions_Pricing_Grand_Total_LabelInputs */



/**
* | output |
* | --- |
* | "Total ({count} jobs):" |
*
* @param {Embed_Captions_Pricing_Grand_Total_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_pricing_grand_total_label = /** @type {((inputs: Embed_Captions_Pricing_Grand_Total_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Pricing_Grand_Total_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Total (${i?.count} tâches) :`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Gesamt (${i?.count} Jobs):`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Totale (${i?.count} lavori):`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Итого (заданий: ${i?.count}):`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Total (${i?.count} trabajos):`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`总计（${i?.count} 个任务）：`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`合計（${i?.count} ジョブ）:`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कुल (${i?.count} जॉब):`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Total (${i?.count} trabalhos):`)
	return /** @type {LocalizedString} */ (`Total (${i?.count} jobs):`)
});